(() => {
  'use strict';
  if (window.__KOLDER_PRODUCT_PAGE__) return;
  window.__KOLDER_PRODUCT_PAGE__ = true;

  const priceFormatter = new Intl.NumberFormat('es-CL', {
    style: 'currency', currency: 'CLP', maximumFractionDigits: 0
  });

  function volumeConfig(productId) {
    for (const node of document.querySelectorAll('script[data-price-tiers]')) {
      try {
        const config = JSON.parse(node.textContent);
        if (String(config.productId) !== String(productId) || !Array.isArray(config.priceTiers)) continue;
        const tiers = config.priceTiers.filter(tier => Number.isInteger(tier.qty) && tier.qty >= 1 && tier.qty <= 999 &&
          tier.variant_id && Number.isFinite(tier.unit_price) && tier.unit_price > 0).slice().sort((a, b) => a.qty - b.qty);
        // Tier prices are pesos; Shopify's basePrice is the cheapest variant in cents.
        const regular = tiers.find(tier => tier.qty === 1)?.unit_price;
        if (!regular) return null;
        const seen = new Set();
        const discounts = tiers.filter(tier => {
          if (tier.qty <= 1 || tier.unit_price >= regular || seen.has(tier.qty)) return false;
          seen.add(tier.qty);
          return true;
        });
        return discounts.length ? { regular, discounts } : null;
      } catch (_) { /* An incomplete section must not display an unverified price. */ }
    }
    return null;
  }

  function updateVolumeState(state) {
    if (!state) return;
    const config = volumeConfig(state.productId);
    if (!config) return;
    let active = null;
    config.discounts.forEach(tier => { if (state.quantity >= tier.qty) active = tier; });
    document.querySelectorAll('[data-kolder-volume-preview]').forEach(container => {
      if (container.dataset.productId !== String(state.productId)) return;
      container.setAttribute('aria-busy', String(state.busy));
      container.querySelectorAll('[data-kolder-volume-tier]').forEach(button => {
        const tierQuantity = Number(button.dataset.kolderVolumeTier);
        const tier = config.discounts.find(candidate => candidate.qty === tierQuantity);
        const inventoryLimit = tier?.inventory_limit == null || tier.inventory_limit === '' ? null : Number(tier.inventory_limit);
        const exceedsStock = Number.isFinite(inventoryLimit) && tierQuantity > inventoryLimit;
        const selected = !!active && tierQuantity === active.qty;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', String(selected));
        button.disabled = state.busy || !state.available || exceedsStock;
      });
      const error = container.querySelector('[data-kolder-volume-error]');
      if (error) {
        error.textContent = state.error;
        error.hidden = !state.error;
      }
    });
    // Preview the eligible tier, or the next minimum when below the first tier.
    const offer = active || config.discounts.find(tier => tier.qty > state.quantity) || config.discounts[0];
    const applied = !!active && state.cartQuantity >= active.qty && !state.busy;
    document.querySelectorAll('[data-kolder-volume-hint]').forEach(hint => {
      if (hint.dataset.productId !== String(state.productId)) return;
      const label = `Compra ${offer.qty} o más por ${priceFormatter.format(offer.unit_price)} cada uno`;
      const text = hint.querySelector('mark');
      if (text && text.textContent !== label) text.textContent = label;
      hint.classList.toggle('is-applied', applied);
      hint.setAttribute('aria-label', (applied ? 'Descuento aplicado. ' : '') + label);
    });
  }

  function renderVolumePreviews(root = document) {
    root.querySelectorAll('[data-kolder-volume-preview]').forEach(container => {
      container.hidden = true;
      container.replaceChildren();
      const config = volumeConfig(container.dataset.productId);
      if (!config) return;
      const title = document.createElement('p');
      title.className = 'kolder-volume-preview__title';
      title.textContent = 'Precios por volumen';
      const list = document.createElement('ul');
      list.className = 'kolder-volume-preview__list';
      list.setAttribute('aria-label', 'Aplicar cantidad y precio por volumen al carro');
      config.discounts.forEach(tier => {
        const item = document.createElement('li');
        const card = document.createElement('button');
        card.type = 'button';
        card.className = 'kolder-volume-preview__card';
        card.dataset.kolderVolumeTier = String(tier.qty);
        card.setAttribute('aria-pressed', 'false');
        card.disabled = true;
        card.setAttribute('aria-label', `Actualizar el carro a ${tier.qty} unidades por ${priceFormatter.format(tier.unit_price)} cada una`);
        const threshold = document.createElement('span');
        threshold.className = 'kolder-volume-preview__threshold';
        threshold.textContent = `Desde ${tier.qty} unidades`;
        const prices = document.createElement('span');
        prices.className = 'kolder-volume-preview__prices';
        const current = document.createElement('strong');
        current.className = 'kolder-volume-preview__current';
        current.textContent = priceFormatter.format(tier.unit_price);
        const regular = document.createElement('s');
        regular.className = 'kolder-volume-preview__regular';
        regular.textContent = priceFormatter.format(config.regular);
        regular.setAttribute('aria-label', `Precio por una unidad: ${priceFormatter.format(config.regular)}`);
        const unit = document.createElement('span');
        unit.className = 'kolder-volume-preview__unit';
        unit.textContent = 'por unidad';
        prices.append(current, regular);
        card.append(threshold, prices, unit);
        card.addEventListener('click', () => {
          if (!card.disabled) window.KolderProductCart?.setQuantity(container.dataset.productId, tier.qty);
        });
        item.append(card);
        list.append(item);
      });
      const error = document.createElement('p');
      error.className = 'kolder-volume-preview__error';
      error.setAttribute('data-kolder-volume-error', '');
      error.setAttribute('role', 'alert');
      error.hidden = true;
      container.append(title, list, error);
      container.hidden = false;
    });
    root.querySelectorAll('[data-kolder-volume-hint]').forEach(hint => {
      hint.hidden = !volumeConfig(hint.dataset.productId);
      if (hint.hidden) return;
      hint.innerHTML = '<svg class="kolder-volume-hint__icon" width="16" height="16" viewBox="0 0 24 24" aria-hidden="true"><path class="kolder-volume-hint__tag" fill="currentColor" d="M3 3h8l10 10-8 8L3 11V3Zm5 3a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"/><path class="kolder-volume-hint__check" d="m4 12 5 5L20 6" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg><mark></mark>';
    });
    root.querySelectorAll('[data-kolder-volume-preview], [data-kolder-volume-hint]').forEach(node => {
      updateVolumeState(window.KolderProductCart?.state(node.dataset.productId) || {
        productId: node.dataset.productId, quantity: 1, cartQuantity: 0, busy: true, available: false, error: ''
      });
    });
  }
  document.addEventListener('kolder:product-state', event => updateVolumeState(event.detail));
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => renderVolumePreviews(), { once: true });
  } else renderVolumePreviews();
  document.addEventListener('shopify:section:load', event => renderVolumePreviews(event.target));

  // The complete nutrition table is always visible below the product columns.
  // Handle this link before the theme's generic anchor listener on body.
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-kolder-nutrition-more]');
    if (!link) return;
    const section = link.closest('[data-section-type="product"]');
    const heading = document.getElementById(link.getAttribute('href').slice(1));
    if (!section || !heading || !section.contains(heading)) return;

    event.preventDefault();
    event.stopPropagation();
    heading.focus({ preventScroll: true });
    const margin = parseFloat(window.getComputedStyle(heading).scrollMarginTop) || 140;
    window.scrollTo({
      top: Math.max(0, window.scrollY + heading.getBoundingClientRect().top - margin),
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
    });
  }, true);
})();
